import type { JSX } from "react";

import { BubbleMenu } from "@tiptap/react/menus";

import { useTextEditorContext } from "./TextEditor.context";
import type {
  TextEditorTool,
  TextEditorToolbarVariant,
} from "./TextEditor.types";
import { TextEditorToolbar } from "./TextEditorToolbar";

export type TextEditorBubbleToolbarProps = {
  tools?: readonly TextEditorTool[];
  variant?: TextEditorToolbarVariant;
  held: boolean;
};

export function TextEditorBubbleToolbar({
  tools,
  variant,
  held,
}: TextEditorBubbleToolbarProps): JSX.Element | null {
  const { editor } = useTextEditorContext();

  if (editor === null) {
    return null;
  }

  return (
    <BubbleMenu
      editor={editor}
      options={{ placement: "top", offset: 8 }}
      shouldShow={({ editor, view, state, from, to, element }) => {
        if (held) {
          return true;
        }

        if (false === editor.isEditable || state.selection.empty) {
          return false;
        }

        if ("" === state.doc.textBetween(from, to).trim()) {
          return false;
        }

        const root = element.getRootNode() as Document | ShadowRoot;

        return view.hasFocus() || element.contains(root.activeElement);
      }}
    >
      <TextEditorToolbar tools={tools} variant={variant} placement="floating" />
    </BubbleMenu>
  );
}
